/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import { BarChart } from '@mui/icons-material'
import {
  Box,
  Button,
  Card,
  ListItemButton,
  ListItemText,
  Typography,
  Tooltip,
} from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { useHistory } from 'react-router-dom'
import { MenuProps } from '~/components/SidebarMenu/interfaces'
import useUserState from '~/features/User/stores/UserState'

function ManagementMenu({ activeMenu, handleMenuClick }: MenuProps) {
  const { translate } = useLang()
  const history = useHistory()
  const { verifyPermission } = useUserState()

  return (
    <>
      {verifyPermission([
        'statistics_dispatch',
        'statistics_device_connection',
        'entry_overview',
      ]) && (
        <Box>
          <Tooltip title={translate('Management')} placement="bottom">
            <Button
              className={`main-menu ${
                activeMenu == 'management' ? 'active' : ''
              }`}
              onClick={() => handleMenuClick('management')}
            >
              <BarChart />
            </Button>
          </Tooltip>
          <Card
            className="submenu-box"
            sx={{
              borderRadius: 0,
              display: activeMenu == 'management' ? 'block' : 'none',
            }}
          >
            <Typography variant="h4" sx={{ textAlign: 'center' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  gap: 1,
                }}
              >
                <BarChart />
                {translate('Management')}
              </Box>
            </Typography>

            {verifyPermission(['statistics_dispatch']) && (
              <Tooltip title={translate('Show statistics')} placement="right">
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('management')
                    history.push('/management/statistics/dispatch')
                  }}
                >
                  <ListItemText primary={translate('Dispatch Statistic')} />
                </ListItemButton>
              </Tooltip>
            )}

            {verifyPermission(['statistics_device_connection']) && (
              <Tooltip
                title={translate('Search connections')}
                placement="right"
              >
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('management')
                    history.push('/management/device/connections')
                  }}
                >
                  <ListItemText primary={translate('Device connections')} />
                </ListItemButton>
              </Tooltip>
            )}
            {verifyPermission(['statistics_device_connection']) && (
              <Tooltip title={translate('Show Word Cloud')} placement="right">
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('management')
                    history.push('/management/wordcloud')
                  }}
                >
                  <ListItemText primary={translate('Word Cloud')} />
                </ListItemButton>
              </Tooltip>
            )}

            {verifyPermission(['statistics_occurrence_qualifiers']) && (
              <Tooltip title={translate('Qualifiers')} placement="right">
                <ListItemButton
                  onClick={() => {
                    handleMenuClick('management')
                    history.push('/management/statistics/qualifiers')
                  }}
                >
                  <ListItemText primary={translate('Qualifiers')} />
                </ListItemButton>
              </Tooltip>
            )}
          </Card>
        </Box>
      )}
    </>
  )
}

export default ManagementMenu
